const storageToken = "ss.tk";
const storageUsuario = "ss.us";
const storageLineaNegocio = "ss.li";
const storageRazonSocial = "ss.rz";
const storageAlertas = "ss.us.al";
const saveStorage = (nombreStorage, data) => {
    try {
        localStorage.setItem(nombreStorage, data);
    } catch (error) {
        //console.log("saveStorage error:", error);
    }
};

const getStorage = (nombreStorage) => {
    try {
        const value = localStorage.getItem(nombreStorage);
        if (value !== null) {
            return value;
        }
    } catch (error) {
        //console.log("getStorage error:", error);
    }
}

const removeStorage = (nombreStorage) => {
    try {
        const value = localStorage.removeItem(nombreStorage);
        if (value !== null) {
            //console.log(value);
        }
    } catch (error) {
        //console.log("removeStorage error:", error);
    }
}

class localStorageCustom {
    constructor(props) {
        this.token = "";
        this.usuario = null;
    }

    saveAlerta(alerta = "") {
        const nPromise =
            saveStorage(storageAlertas, JSON.stringify(alerta))
            .then(() => { this.alerta = alerta; })
            .catch(error => {
                throw new Error("saveAlerta error" + error);
            });
        return nPromise;
    }
    getAlerta() {
        let data = getStorage(storageAlertas);
        return data == null ? null : JSON.parse(data);
        // const nPromise =
        //     getStorage(storageAlertas)
        //     .then(alerta => {
        //         if (alerta)
        //             return JSON.parse(alerta);
        //         else return null;
        //     })
        //     .catch(error => {
        //         throw new Error("getAlerta error" + error);
        //     });
        // return nPromise;
    }

    saveToken(token = "") {
        saveStorage(storageToken, JSON.stringify(token));
        this.token = token;
        return token;
        // const nPromise =
        //     saveStorage(storageToken, JSON.stringify(token))
        //     .then(() => { this.token = token; return token; })
        //     .catch(error => {
        //         throw new Error("saveToken error" + error);
        //     });
        // return nPromise;
    }
    getToken() {
        let data = getStorage(storageToken);
        return data == null ? null : JSON.parse(data);
        // const nPromise =
        //     getStorage(storageToken)
        //     .then(token => {
        //         if (token)
        //             return JSON.parse(token);
        //         else return null;
        //     })
        //     .catch(error => {
        //         throw new Error("obtenerToken error" + error);
        //     });
        // return nPromise;
    }
    removeToken() {
        removeStorage(storageToken);
        this.token = "";
        // const nPromise =
        //     removeStorage(storageToken)
        //     .then(() => { this.token = ""; })
        //     .catch(error => {
        //         throw new Error("removeToken error" + error);
        //     });
        // return nPromise;
    }
    saveLineaNegocio(linea = "") {
        saveStorage(storageLineaNegocio, JSON.stringify(linea));
        this.linea = linea;
        // const nPromise =
        //     saveStorage(storageLineaNegocio, JSON.stringify(linea))
        //     .then(() => { this.linea = linea; })
        //     .catch(error => {
        //         throw new Error("saveLineaNegocio error" + error);
        //     });
        // return nPromise;
    }
    getLineaNegocio() {
        let data = getStorage(storageLineaNegocio);
        return data == null ? null : JSON.parse(data);
        // const nPromise =
        //     getStorage(storageLineaNegocio)
        //     .then(linea => {
        //         if (linea)
        //             return JSON.parse(linea);
        //         else return null;
        //     })
        //     .catch(error => {
        //         throw new Error("getLineaNegocio error" + error);
        //     });
        // return nPromise;
    }
    saveUsuario(usuario = "") {
        saveStorage(storageUsuario, JSON.stringify(usuario));
        this.usuario = usuario;
        // const nPromise =
        //     saveStorage(storageUsuario, JSON.stringify(usuario))
        //     .then(() => { this.usuario = usuario; })
        //     .catch(error => {
        //         throw new Error("saveUsuario error" + error);
        //     });
        // return nPromise;
    }
    getUsuario() {
        let data = getStorage(storageUsuario);
        return data == null ? null : JSON.parse(data);
        // const nPromise =
        //     getStorage(storageUsuario)
        //     .then(usuario => {
        //         if (usuario)
        //             return JSON.parse(usuario);
        //         else return null;
        //     })
        //     .catch(error => {
        //         throw new Error("getUsuario error" + error);
        //     });
        // return nPromise;
    }
    saveRazonSocial(razonssocial = "") {
        saveStorage(storageRazonSocial, JSON.stringify(razonssocial));
        this.razonssocial = razonssocial;
        // const nPromise =
        //     saveStorage(storageRazonSocial, JSON.stringify(razonssocial))
        //     .then(() => { this.razonssocial = razonssocial; })
        //     .catch(error => {
        //         throw new Error("saveRazonSocial error" + error);
        //     });
        // return nPromise;
    }
    getRazonSocial() {
        let data = getStorage(storageRazonSocial);
        return data == null ? null : JSON.parse(data);
        // const nPromise =
        //     getStorage(storageRazonSocial)
        //     .then(razonssocial => {
        //         if (razonssocial)
        //             return JSON.parse(razonssocial);
        //         else return null;
        //     })
        //     .catch(error => {
        //         throw new Error("getRazonSocial error" + error);
        //     });
        // return nPromise;
    }
    removeUsuario() {
        removeStorage(storageUsuario);
        this.usuario = null;
        // const nPromise =
        //     removeStorage(storageUsuario)
        //     .then(() => { this.usuario = null })
        //     .catch(error => {
        //         throw new Error("removeUsuario error" + error);
        //     });
        // return nPromise;
    }
}
export default localStorageCustom;